import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

// Canonical way to call a Cloud Function from the web-app. The `functions`
// instance and its emulator wiring live in firebase.js (real/deployed dev by
// default, local emulator only when opted in); this just binds a function name
// to it. Use `createCallable('functionName')` everywhere instead of building
// httpsCallable(getFunctions(...), ...) ad hoc, so every caller shares the one
// correctly-configured instance.
//
// `options` is the optional HttpsCallableOptions passed straight through to
// httpsCallable — e.g. `createCallable('chat', { timeout: 480000 })` for the
// long-running tools that need more than Firebase's 70s default.
export const createCallable = (functionName, options) =>
  httpsCallable(functions, functionName, options);
